module.exports = __webpack_public_path__ + "img/55.5.COD.c7a73edd.png";